import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-dialog-header-student',
    templateUrl: './dialog-header-student.component.html',
    styleUrls: ['./dialog-header-student.component.css'],
    standalone: false
})
export class DialogHeaderStudentComponent {

  @Input() titulok: string;
  @Input() predmetNazov: string;
  @Input() predmetyPole: string;
  @Input() predmetSkratka: string;
  @Input() predmetRozsah: string;

  @Input() skratkyANazvyPredmetov: string[][];

}
